module.exports = __webpack_public_path__ + "files/privacy-policy.pdf";